import React from "react";
import { Input, Row, Typography, Form, Col } from "antd";
const { Text } = Typography;

const CurrencyConfig = (props) => {
  const { onFinish, form, formData, glDetail } = props;
  const displayValue = (value) =>
    value !== undefined && value !== null && value !== "" ? value : "-";
  const yesNo = (value) => (value === true ? "Yes" : value === false ? "No" : "-");
  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={formData}>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Currency Code</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.currencyCode || glDetail?.currency?.code)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Multi Currency Allowed</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={yesNo(glDetail?.multiCurrencyAllowed)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Revaluation Required</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={yesNo(glDetail?.revaluationRequired)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Revaluation GL Account</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                glDetail?.revaluationGlAccount?.name ||
                  glDetail?.revaluationGlAccountId ||
                  glDetail?.revaluationGlAccount,
              )}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CurrencyConfig;
